import React from "react";
import NavBar from "../components/NavBar";
import AuthContainer from "../components/auth/AuthLogin";
const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <NavBar />
      <div className="container mx-auto p-8">
        <div className="bg-white rounded-lg shadow-xl p-6 md:p-12">
          <div className="text-center">
            <h2 className="text-4xl font-bold mb-2">What are your habits?</h2>
            <p className="mb-6 mt-8">
              by{" "}
              <a
                href="https://www.moisestrejo.com/"
                className="text-indigo-600 hover:text-indigo-800 transition duration-300"
              >
                Moises Trejo
              </a>
            </p>
          </div>
          <div className="flex justify-center items-center">
            <AuthContainer />
          </div>
          <div className="md:flex gap-16 mt-16">
            <div className="mb-6 md:w-[50%]">
              <h3 className="text-2xl font-semibold text-center">
                What is this?
              </h3>
              <p className="bg-gray-100 p-4 mt-2 rounded-md ">
                Enter your daily goals and see them work their magic!
              </p>
            </div>
            <div className="mb-6 md:w-[50%]">
              <h3 className="text-2xl font-semibold text-center">
                How does it work?
              </h3>
              <p className="bg-gray-100 p-4 mt-2 rounded-md">
                Get a reminder everyday to set your goals
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
